import { configureStore } from "@reduxjs/toolkit";

import layoutReducer from "./layout";
import essentialReducer from "./essentials";
import planningReducer from "./planning";
import storeReducer from "./store";
import authReducer from "./auth";
import generalReducer from "./general";
import messageReducer from "./message";

export const store = configureStore({
  reducer: {
    general: generalReducer,
    layout: layoutReducer,
    essentials: essentialReducer,
    planning: planningReducer,
    store: storeReducer,
    auth: authReducer,
    message: messageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
